import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomParamDetailComponent } from './custom-param-detail.component';
import {ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {CoreModule} from "../../core/core.module";

@NgModule({
  declarations: [CustomParamDetailComponent],
  exports: [
    CustomParamDetailComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    CoreModule
  ]
})
export class SharedCustomParamDetailModule { }
